module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAPJJREFUSEvNlbsRglAQRc/qGEtiagMGrwVLsAQ7UDvRCrQE7QArEKxAEyMDMyN9DowwKPhkmWGAdD+He3cXhJofqbk/zQJsyBbwxbAsUvovHtXkFNgDHh1m74ZThBMW/4eV2fhNDKvvvDwgIEAwFWezEsM8W5sHhNiKzaOyvRjG5QERyrUG+bgSoJfSJkDHg+Eaup5bxz2AyyLJUSiIAIOPhSgGPW5wTc9EAdD7X2GL9BCFgtii5KAdpNii9ICVgOGm5JDTWSkAenvaNoOWKtiJYeL+2B2Z8mSJ0FeJsJzpMZERgROgaloiudl/cokX/JvyAnDsZxlH1vdbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/home-active.png
// module id = E0kh
// module chunks = 1